import React from "react";
import { Caption, Photo, PhotoContainer } from "./About.styles";
import Logo from "../../components/logos/Logo/Logo";
import SectionTitle from "../../components/section-items/SectionTitle/SectionTitle";
import SectionText from "../../components/section-items/SectionText/SectionText";
import SectionContainer from "../../components/section-items/SectionContainer/SectionContainer";
import Section from "../../components/section-items/Section/Section";
import { ABOUT_TEAM, MAIN_IMAGE_CAPTION } from "../../utils/info";

const About = () => {
    return (
        <Section theme={"light"}>
            <PhotoContainer>
                <Photo src={"/team.png"} />
                <Caption>{MAIN_IMAGE_CAPTION}</Caption>
            </PhotoContainer>
            <SectionContainer style={{ flex: 3 }}>
                <SectionTitle>{"O NASZYM KLUBIE"}</SectionTitle>
                <SectionText>{ABOUT_TEAM}</SectionText>
            </SectionContainer>
            <Logo
                width={600}
                height={600}
                style={{
                    position: "absolute",
                    right: -160,
                    bottom: -140,
                    opacity: 0.07,
                    transform: "rotate(12deg)",
                }}
            />
        </Section>
    );
};

export default About;
